<template>
  <donut-slack-preview
    avatar-path="graphics/shoutouts/user-headshot-2"
    :avatar-version="0"
    :hide-name="true"
    :message="message"
    :reacji-list="props.reacjiList"
  />
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state, getters } = useStore();
  const props = defineProps({
    points: { type: Number, default: 3 },
    emoji: { type: String, default: null },
    hashtag: { type: String, default: null },
    reacjiList: { type: Array, default: () => [{ emoji: 'heart', count: 9 }, { emoji: 'tada', count: 2 }] },
  });

  const message = computed(() => {
    const emoji = props.emoji || state.pointsConfig.config.emoji;
    return `Shoutout ${getters['pointsConfig/emojiMultiplier']({ points: props.points, emoji })} to :::@will::: `
      + `for crushing the product launch!${props.hashtag ? ` #${props.hashtag}` : ''}`;
  });
</script>
